module.exports = __webpack_public_path__ + "img/49.73874262.png";